/**
 * @packageDocumentation
 * @module Object
 */
import { removeFromBaseFunction } from './removeFromBaseFunction';
import { normalisePath } from '../normalisePath';
/**
 * Immutably removes an item from an object or array at a given path, denoted by dot notation or an array.
 *
 * If the item is already removed nothing is changed. i.e. values is returned.
 *
 * @param {object} values
 * @param {string|string[]} path
 *
 * @return {object}
 */
export var removeFrom = function (values, path) { return removeFromBaseFunction(values, normalisePath(path)); };
//# sourceMappingURL=removeFrom.js.map